import { Box, Button } from "@mui/material";
import { useRecoilState } from "recoil";
import ControlPointOutlinedIcon from "@mui/icons-material/ControlPointOutlined";
import {
  shipmentHideState,
  startShipmentReceiverAnimationState,
} from "../../../atoms/createShipment";

const AddReceiverAddress = () => {
  const [, setStartShipmentReceiverAnimation] = useRecoilState(
    startShipmentReceiverAnimationState
  );
  const [, setShipmentHide] = useRecoilState(shipmentHideState);

  const addressAddHandler = () => {
    setStartShipmentReceiverAnimation(true);
    setShipmentHide(true);
  };

  return (
    <Box
      className="new-address-adder-wrapper"
      style={{ justifyContent: "flex-start" }}
    >
      <Button
        sx={{
          color: "var(--btnBgBlue)",
          textTransform: "none",
          display: "flex",
          alignItems: "center",
          gap: "5px",
          fontSize: "14px",
          fontWeight: 600,
        }}
        onClick={addressAddHandler}
      >
        <ControlPointOutlinedIcon />
        Yeni Alıcı Adresi Ekle
      </Button>
    </Box>
  );
};

export default AddReceiverAddress;
